import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {Object} from 'es6-shim';
import {IListini} from '../../../../commons/interfaces/listini';
import {FileService} from '../../../../services/file.service';

// stessa Classe enum da archivist.archismall.util.enums per i tipi di limite
const Limit = {
  FE: 'FE',
  CE: 'CE',
  PEC: 'PEC',

};

class GestioneProfiliController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$stateParams',
    '$filter',
    'UiSelectService',
    'FileService',
  ];

  constructor(
    private $scope: {
      listini: IListini[]
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $stateParams: ng.ui.IStateParamsService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
    private fileService: FileService,
  ) {
    $scope.entries = Object.entries;
    $scope.pageHeader = 'Gestione Profili Archismall';
    $scope.pageSubHeader = '';
    $rootScope.formsubmitted = false;

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.exportCsv = (item: IListini) => {
      fileService.downloadCsv(ArchiSmallServices.getListinoCsv(item._id));
    };

    $scope.getListini = () => {
      // logica per prendere dal database i profili
      ArchiSmallServices.getListini().then((response) => {
        $scope.listini = JSON.parse(JSON.stringify(response)) as IListini[];
        $scope.listini.sort((a, b) => a.name.localeCompare(b.name));
      }, (error) => {
        console.error(error);
      });
    };
    $scope.getListini();

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };


    $scope.openConfermaModal = (size) => {
      // console.log(originalUsers);

      // fare modal per conferma o altro vedi poi

      // let ConfermaModal = $uibModal.open({
      //     animation: true,
      //     component: 'confermaComponent',
      //     size: size,
      //     windowClass: 'center-modal',
      //     backdrop: 'static',
      //     keyboard: false,
      //     resolve: {
      //         user: () => {
      //             return user;
      //         },
      //         otherUpdate: true,
      //         diffs: () => {
      //           return user.last_differences;
      //         }
      //     }
      // });

      // setTimeout($scope.getListini, 3000);

    };

    $scope.creaListino = () => {
      $state.go('home.crea-listino');
    };

    $scope.delete = (item, size) => {

      let modalInstance = $uibModal.open({
        animation: $scope.animationsEnabled,
        component: 'defaultModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          config: () => {
            return {
              headerIcon: 'fa fa-exclamation-triangle',
              headerText: 'Attenzione',
              bodyHtml: `Sei sicuro di voler cancellare il listino ${item.name}?`,
              buttons: [
                {
                  'id': 1,
                  'icon': 'fa fa-ban',
                  'label': 'Annulla'
                },
                {
                  'id': 2,
                  'icon': 'fa fa-check-circle-o',
                  'label': 'Si'
                }
              ]
            };
          }
        }
      });

      modalInstance.result.then((pressedButtonId) => {
        if (pressedButtonId !== undefined && Number(pressedButtonId) === 2) {
          let ConfermaModal = $uibModal.open({
            animation: true,
            component: 'confermaComponent',
            size: size,
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              listiniUpdate: true,
              listino: () => {
                return item;
              }
            }
          });

          setTimeout($scope.getListini, 3000);
        }
      }, (error) => {
        // ?
      });

    };


    $scope.open = (item: IListini, limite: string) => {

      // const setLimitStore = limite;
      // store.set(`${setLimitStore}`, limite);
      store.set('idListino', item._id);
      $state.go('home.gestione-listino', {limit: limite});
    };
  }
}

export const GestioneProfiliComponent: ng.IComponentOptions = {
  template: require('./gestione-profili.html'),
  controller: GestioneProfiliController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/gestione-profili.ts